export function getCurrentIsoWeek(): string {
  return dateToIsoWeek(new Date());
}

export function dateToIsoWeek(date: Date): string {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  const weekNo = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  return `${d.getFullYear()}-W${String(weekNo).padStart(2, '0')}`;
}

export function isoWeekToMondayDate(isoWeek: string): Date {
  const parts = isoWeek.split('-W');
  const y = parseInt(parts[0] ?? '0', 10);
  const w = parseInt(parts[1] ?? '1', 10);
  // Jan 4 is always in ISO week 1
  const jan4 = new Date(y, 0, 4);
  const jan4Day = jan4.getDay() || 7;
  const monday = new Date(jan4);
  monday.setDate(jan4.getDate() - jan4Day + 1 + (w - 1) * 7);
  return monday;
}

export function isoWeekToMonday(isoWeek: string): string {
  const d = isoWeekToMondayDate(isoWeek);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function addWeeks(isoWeek: string, n: number): string {
  const d = isoWeekToMondayDate(isoWeek);
  d.setDate(d.getDate() + n * 7);
  return dateToIsoWeek(d);
}

export function formatDuration(totalSeconds: number): string {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  return `${h}:${String(m).padStart(2, '0')}`;
}

export function formatWeekLabel(weekStartDate: string, weekEndDate: string): string {
  const start = new Date(weekStartDate + 'T12:00:00');
  const end = new Date(weekEndDate + 'T12:00:00');
  const startDay = start.getDate();
  const endFormatted = end.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  return `${startDay}–${endFormatted}`;
}
